import React, { useState } from 'react';
import { Card } from '../base/components/CardAccordion';
import PropControl from '../base/components/PropControl';
import Money from '../base/data/Money';
import DataStore from '../base/plumbing/DataStore';


/**
 * Controls for the Wider Impact of an Impact Hub
 */
function ImpactHubWiderImpactControls({campaignPath}) {
	const [collapsed, setCollapsed] = useState(true);

	const show = DataStore.getValue(campaignPath.concat('showWiderImpact'));
	const dntn = DataStore.getValue(campaignPath.concat('widerAnnualDntn'));
	const quote = DataStore.getValue(campaignPath.concat('widerImpactQuote'));

	const warnings = [];
	if (show) {
		if (!dntn || !Money.value(dntn)) warnings.push("Without a set donation, the Impact Hub splash will not change.");
		if (!quote) warnings.push("A quote has not been set, and nothing will display.");
	}

	const warning = warnings.join("\n");

	return <Card title="Wider Impact" onHeaderClick={() => setCollapsed(!collapsed)} collapse={collapsed} warning={warning}>
		<PropControl label="Show the Wider Impact" prop="showWiderImpact" path={campaignPath} type="checkbox" 
			help="Format this Impact Hub as one with a wider impact display."
		/>
		<br/>
		<PropControl label="Annual Donation Amount" path={campaignPath} prop="widerAnnualDntn" changeCurrency
			type="Money"
			help={<>
				How much money is raised in total by this entity.&nbsp;
				{show && (!dntn || !Money.value(dntn)) && <span className="text-warning">Without a set donation, the Impact Hub splash will not change.</span>}
			</>}
		/>
		<PropControl label="Website link" path={campaignPath} prop="widerUrl"
			type="text"
			help="A link to a website showing the entity's wider impact."
		/>
		<PropControl label="Quote" path={campaignPath} prop="widerImpactQuote"
			type="textarea"
			help={<>
				Shown in a blue quote box underneath the splash.&nbsp;
				{show && !quote && <span className="text-warning">A quote has not been set, and nothing will display.</span>}
			</>}
		/>
	</Card>;
}


export default ImpactHubWiderImpactControls;
